import {API_URL, apiDelete} from '../api'

export const deleteBadge = async (id: string) => {
    return await apiDelete(API_URL, `admin/badges/${id}`)
}
